export default {team:'Varelager',changelog_page:'pages-entur-plass-changelog',api_service:'seating-overrides',changes:[]}